<script setup>
import Footer from "@/partials/hardware/shop/Footer.vue"
</script>

<template>
  <div class="flex flex-col min-h-screen overflow-hidden">
    <router-view></router-view>
    <!-- Site footer -->
    <Footer />
  </div>
</template>
